import {injectGlobal} from 'emotion';
import {lighten, textInputs, darken} from 'polished';

import 'typeface-roboto';
import 'semantic-ui-css/semantic.css';
import 'toastr/build/toastr.min.css';

export const colors = {
  black: '#1B1C1D',
  yellowDark: '#E2AF37',
  yellowLight: lighten(0.1, '#E2AF37'),
  errorText: '#9F3A38',
  contentBackground: '#FFF',
  headerBackground: '#F6F6F6',
  textLabel: '#8E8776',
  goldPrimary: '#9fa273',
  greenPrimary: '#37817a',
  greenSecondary: '#2e4040',
};

/* eslint-disable indent */
injectGlobal`
  html, body {
      background: #fbfbfb;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;

    .ui.menu .ui.dropdown .menu > .item {
      color: #8E8776 !important;

      &:hover {
        color: #8E8776 !important;
      }
    }

    *:not(.icon) {
      font-family: 'Roboto', sans-serif !important;
    }

    .muted {
      color: #bbb;
    }

    .ui {

      &.form {
        margin-bottom: 15px;

        ${textInputs()} {
          border-width: 2px;
        }

        .dropdown,
        .selection.dropdown {
          border-width: 2px;

          .menu {
            border-width: 2px;
            margin: 0px -2px;
            min-width: calc(100% + 4px);
            width: calc(100% + 4px);
          }
        }

        .field > label {
          color: ${colors.textLabel};
        }
      }

      .stacked-buttons .button{
        margin-bottom: 10px;
      }

      &.secondary.pointing.menu {
          .item {
            color: ${lighten(0.1, colors.textLabel)};
          }

         .active.item {
          border-color: #DFAE38;
          color: ${colors.textLabel};
        }

        .active.item:hover {
          border-color: ${darken(0.1, '#DFAE38')};
          color: ${darken(0.1, colors.textLabel)};
        }
      }

      &.buttons .button,
      &.button {

        &.primary,
        &.primary & {
          background-color: ${colors.yellowDark};

          .button:hover,
          .button:focus,
          &:hover,
          &:focus {
            background-color: ${colors.yellowLight};
          }
        }

        &.clear,
        &.clear & {
          background-color: #FFF;

          .button:hover,
          .button:focus,
          &:hover,
          &:focus {
            background-color: #e8e8e8;
          }
        }

        &.link {
          background: transparent;
          text-decoration: underline;
        }
      }

      &.table {
        color: #8E8776;

        &.table tr th {
          border-left: none;
        }

        &.table tr td {
          border-top: none;
        }

        &.celled tr th {
          border-left: 1px solid rgba(222, 222, 222, 0.43);
        }

        thead th {
          background: ${lighten(
            0.2,
            colors.black
          )} -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
          background: ${lighten(
            0.2,
            colors.black
          )} -o-linear-gradient(transparent, rgba(0, 0, 0, 0.05));
          background: ${lighten(0.2, colors.black)}
            linear-gradient(transparent, rgba(0, 0, 0, 0.05));
          color: ${lighten(0.1, colors.textLabel)};
        }

        td:first-child {
          padding-left: 10px !important;
        }
      }

      &.header {
        color: ${colors.textLabel};

        small {
          font-size: 50%;
        }
      }

      &.container {
        @media only screen and (max-width: 767px) {
          width: auto !important;
          margin-left: 0.25em !important;
          margin-right: 0.25em !important;
        }
      }

      .modal > .actions {
        text-align: left;
      }
    }

    #toast-container > div {
      opacity: 1;
    }

    .page-fill {
      padding: 15px 45px;
      background: #FFF;

      @media (max-width: 767px) {
        padding: 15px 15px;
      }
    }

    .ui.selection.dropdown {
      min-width: 10em;
    }

    .ui.selection.dropdown,
    .ui.button.clear.action {
      border-radius: 0;
      border: 2px solid rgba(34, 36, 38, 0.15);
    }

    .ui.button.clear.action {
      background-color: #9fa074;
      top: 1px;
    }
  }
`;
/* eslint-enable indent */
